import { mapGetters, mapActions, mapMutations } from "vuex";

import * as auctionBannerStore from "@/store/auctionBanner";

export { auctionBannerStore };

/**
 * Search store.
 *
 * @param {('actions' | 'getters' | 'mutations')[]} without - Exclude store actions or mutation or getters.
 */
export const createAuctionBannerMixin = (without = []) => {
  const actions = !without.includes("actions")
    ? mapActions(auctionBannerStore.moduleName, Object.keys(auctionBannerStore.actionTypes))
    : {};
  const getters = !without.includes("getters")
    ? mapGetters(auctionBannerStore.moduleName, Object.keys(auctionBannerStore.getterTypes))
    : {};
  const mutations = !without.includes("mutations")
    ? mapMutations(auctionBannerStore.moduleName, Object.keys(auctionBannerStore.mutationTypes))
    : {};

  return {
    methods: {
      ...actions,
      ...mutations
    },
    computed: {
      ...getters
    }
  };
};
